// src/composables/ThemeToggle.ts
import { ref, onMounted } from 'vue'

const isDark = ref(false)

function updateTheme() {
    document.documentElement.classList.toggle('dark', isDark.value)
}

function toggleTheme() {
    isDark.value = !isDark.value
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
    updateTheme()
}

// ✅ Run immediately on import
const stored = localStorage.getItem('theme')

if (stored === 'dark' || stored === 'light') {
    isDark.value = stored === 'dark'
} else {
    isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches
}

updateTheme()

export { isDark, toggleTheme }

